var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.645%",
    y1: "14.645%",
    x2: "85.355%",
    y2: "85.355%",
    id: "linearGradient-r9sbh9sfbs-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21AD64",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#088242",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Broken-down-in-separate-pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Confirmation",
    transform: "translate(-184.000000, -191.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card-1",
    transform: "translate(12.000000, 155.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-confirmat",
    transform: "translate(172.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,30 C60,46.5675 46.5675,60 30,60 C13.4325,60 0,46.5675 0,30 C0,13.4325 13.4325,0 30,0 C46.5675,0 60,13.4325 60,30 Z",
    id: "Path",
    fill: "url(#linearGradient-r9sbh9sfbs-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.258,18.258 L27,33.516 L19.242,25.758 C18.0705,24.5865 16.1715,24.5865 15,25.758 L12.879,27.879 C11.7075,29.0505 11.7075,30.9495 12.879,32.121 L24.879,44.121 C26.0505,45.2925 27.9495,45.2925 29.121,44.121 L48.621,24.621 C49.7925,23.4495 49.7925,21.5505 48.621,20.379 L46.5,18.258 C45.3285,17.0865 43.4295,17.0865 42.258,18.258 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4085,43.5915 L13.4085,31.5915 C12.5295,30.7125 12.5295,29.2875 13.4085,28.41 L15.5295,26.289 C16.4085,25.41 17.8335,25.41 18.711,26.289 L27,34.5765 L42.7875,18.789 C43.6665,17.91 45.0915,17.91 45.969,18.789 L48.09,20.91 C48.969,21.789 48.969,23.214 48.09,24.0915 L28.59,43.5915 C27.7125,44.469 26.2875,44.469 25.4085,43.5915 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9395,43.0605 L13.9395,31.0605 C13.353,30.474 13.353,29.5245 13.9395,28.9395 L16.0605,26.8185 C16.647,26.232 17.5965,26.232 18.1815,26.8185 L27,35.637 L43.3185,19.3185 C43.905,18.732 44.8545,18.732 45.4395,19.3185 L47.5605,21.4395 C48.147,22.026 48.147,22.9755 47.5605,23.5605 L28.0605,43.0605 C27.4755,43.647 26.5245,43.647 25.9395,43.0605 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.afc436fe2b88519fa72d2b9d68f51a9d.svg";
export { ForwardRef as ReactComponent };